export const HOMEPAGE_ROUTE = "/"
export const SIGN_IN_ROUTE = "/signin"
export const SIGN_UP_ROUTE = "/signup"
export const USER_CONFIRMATION_ROUTE = "/confirm/:userId/:confirmation"
export const FORGOT_ROUTE = "/forgot"
export const RESET_CONFIRMATION_ROUTE = "/reset/:userId/:confirmation"
export const DASHBOARD_ROUTE = "/dashboard"
export const REPLENISHMENT_ROUTE = "/replenishment"
export const REPLENISHMENT_VIEW_ROUTE = "/replenishment/:id"
export const getReplenishmentViewRoute = (id: number) => `/replenishment/${id}`
export const REPLENISHMENT_BILL_ROUTE = "/replenishment/:id/bill"
export const REPLENISHMENT_NEW_ROUTE = "/replenishment/new"
export const CURRENCY_REPLENISHMENT_ROUTE = "/currency-replenishment"
export const CURRENCY_REPLENISHMENT_VIEW_ROUTE = "/currency-replenishment/:id"
export const getCurrencyReplenishmentViewRoute = (id: number) => `/currency-replenishment/${id}`
export const CURRENCY_REPLENISHMENT_BILL_ROUTE = "/currency-replenishment/:id/bill"
export const CURRENCY_REPLENISHMENT_NEW_ROUTE = "/currency-replenishment/new"
export const ORDER_ROUTE = "/order"
export const ORDER_VIEW_ROUTE = "/order/:id"
export const ORDER_NEW_ROUTE = "/order/new"
export const REQUEST_ROUTE = "/request"
export const PROFILE_ROUTE = "/profile"
export const COMPANY_VIEW_ROUTE = "/company/:id"
export const getCompanyViewRoute = (id: string) => `/company/${id}`
export const RATES_ROUTE = "/rates"
export const CURRENCY_EXCHANGE_ROUTE = "/currency-exchange"
export const BASE_RATES = "/base-rates"
export const BALANCE_ROUTE = "/balance"
export const BALANCE_UPLOAD_ROUTE = "/balance/upload"

// client
export const CLIENT_COMPANY_ROUTE = "/client/company"
export const CLIENT_CONTRACTOR_ROUTE = "/client/contractor"
export const CLIENT_CONTRACTOR_NEW_ROUTE = "/client/contractor/new"
export const CLIENT_CONTRACTOR_VIEW_ROUTE = "/client/contractor/:id"

// admin
export const ADMIN_COMPANY_ROUTE = "/admin/company"
export const ADMIN_COMPANY_VIEW_ROUTE = "/admin/company/:id"
export const getAdminCompanyViewRoute = (id?: string) => `/admin/company/${id}`
export const ADMIN_COMPANY_NEW_ROUTE = "/admin/company/new"
export const ADMIN_BROCKMAN_VIEW_ROUTE = "/admin/brockman/:id"
export const ADMIN_BROCKMAN_DETAIL_ROUTE = "/admin/brockman/:id/detail"
export const ADMIN_USER_ROUTE = "/admin/user"
export const ADMIN_USER_NEW_ROUTE = "/admin/user/new"
export const ADMIN_USER_VIEW_ROUTE = "/admin/user/:id"
export const getAdminUserViewRoute = (id?: number) => `/admin/user/${id}`
export const ADMIN_RATE_SETTINGS_ROUTE = "/admin/rate-settings"

// manager
export const MANAGER_BROCKMAN_VIEW_ROUTE = "/manager/brockman/:id"
